import { render, staticRenderFns } from "./ManageCustomReport.vue?vue&type=template&id=622ab933&scoped=true"
import script from "./ManageCustomReport.vue?vue&type=script&lang=js"
export * from "./ManageCustomReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ab933",
  null
  
)

export default component.exports